import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllNotifications = async (): Promise<any> => {
  try {
    const userId = getUserId();
    if (!userId) throw new Error("User ID not found. Please log in again.");

    let url = `/adminNotifications/${userId}`;
   
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendAllNotification = async (branchData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/sendNotificationToAll", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendNotificationToClient = async (
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.post("/sendNotificationToClient", branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendNotificationToVenue = async (
  payload: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.post("/sendNotificationToVenue", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendNotificationToOrganization = async (
  payload: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.post(
      "/sendNotificationToAllOrganization",
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateNotification = async (
  id: string,
  branchData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/notifications/${id}`, branchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteNotification = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/notifications/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
